<main class="document-wrapper">
  <div class="document-wrapper__content">
    <!--        -->
    <h1>Privacy Policy</h1>

    <h2>Fr8bot Privacy Policy</h2>
    <h2>
      FR8BOT TAKES YOUR PRIVACY SERIOUSLY. PLEASE READ THE FOLLOWING TO LEARN MORE ABOUT OUR PRIVACY
      POLICY.
    </h2>
    <h2>Updated: March 2026</h2>

    <h2>INTRODUCTION</h2>
    <p>
      This Privacy Policy (“Policy”) describes how Fr8bot, Inc. (“Fr8bot”, “we”, “us”, or “our”)
      collects, uses, and protects Personal Information through our website, platform, mobile
      applications, and any associated services (collectively, the “Platform”).
    </p>
    <p>
      Our Platform may contain links to third-party websites or services. Fr8bot is not responsible
      for the privacy practices of such third parties. We encourage you to review their privacy
      policies separately.
    </p>
    <p>
      We may update this Policy from time to time. Updates become effective upon posting. If
      material changes are made, we may notify you via email or through the Platform.
    </p>

    <h2>PERSONAL INFORMATION</h2>
    <p>
      “Personal Information” means any information that identifies or relates to an individual,
      including but not limited to:
    </p>
    <ul>
      <li>Name</li>
      <li>Address</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>Payment details</li>
      <li>Company or business information</li>
      <li>Usage history within the Fr8bot platform</li>
    </ul>

    <h2>INFORMATION COLLECTION</h2>
    <p>Fr8bot may collect Personal Information when you:</p>
    <ol>
      <li>Use our Platform</li>
      <li>Book, manage, or track shipments</li>
      <li>Register an account</li>
      <li>Submit load requests or carrier information</li>
      <li>Apply to become a driver, carrier, or partner</li>
      <li>Contact support or submit inquiries</li>
      <li>Participate in surveys, promotions, or communications</li>
      <li>Opt in to SMS or email notifications</li>
    </ol>
    <p><b>Types of data we collect include:</b></p>
    <ul>
      <li>Identifiers (name, phone, email, address)</li>
      <li>Business and shipment details</li>
      <li>Device and network information (IP address, browser type, OS)</li>
      <li>Location data (including GPS when enabled)</li>
      <li>Platform usage and interaction data</li>
    </ul>
    <p>
      We may also use cookies and similar technologies to enhance user experience and analyze
      traffic.
    </p>

    <h2>COOKIES AND TRACKING</h2>
    <p>Fr8bot uses cookies and analytics tools to:</p>
    <ul>
      <li>Improve platform performance</li>
      <li>Analyze usage behavior</li>
      <li>Personalize user experience</li>
    </ul>
    <p>
      You may disable cookies via your browser settings, but some features may not function
      properly.
    </p>

    <h2>CHILDREN’S PRIVACY</h2>
    <p>
      Fr8bot does not knowingly collect Personal Information from individuals under 13 years of age.
      If such information is identified, it will be deleted promptly.
    </p>

    <h2>USE OF INFORMATION</h2>
    <p>Fr8bot uses Personal Information to:</p>
    <ul>
      <li>Facilitate freight matching and shipment execution</li>
      <li>Process payments and invoices</li>
      <li>Provide customer support</li>
      <li>Manage user accounts</li>
      <li>Evaluate carrier and driver applications</li>
      <li>Improve platform performance and services</li>
      <li>Communicate operational updates, alerts, and offers (if opted in)</li>
    </ul>
    <p>We may also use data for analytics, fraud prevention, and compliance purposes.</p>

    <h2>CONFIDENTIALITY AND SECURITY</h2>
    <p>We restrict access to Personal Information to authorized personnel only.</p>
    <p>Fr8bot implements:</p>
    <ul>
      <li>Administrative controls</li>
      <li>Technical safeguards</li>
      <li>Secure data storage systems</li>
      <li>Encryption (including SSL where applicable)</li>
    </ul>
    <p>However, no system is 100% secure, and users should take precautions when sharing data.</p>

    <h2>INFORMATION SHARING</h2>
    <p>Fr8bot does <b>not sell Personal Information.</b></p>
    <p>We may share data with:</p>
    <ul>
      <li>Carriers, shippers, and logistics partners involved in shipment execution</li>
      <li>Service providers (payment processors, cloud services, analytics tools)</li>
      <li>Legal authorities, when required by law</li>
      <li>Advisors (legal, financial, auditors)</li>
      <li>In connection with mergers, acquisitions, or asset transfers</li>
    </ul>
    <p>SMS opt-in data and consent are <b>never shared for marketing purposes.</b></p>

    <h2>DATA RETENTION</h2>
    <p>We retain Personal Information only as long as necessary for:</p>
    <ul>
      <li>Business operations</li>
      <li>Legal compliance</li>
      <li>Dispute resolution</li>
    </ul>
    <p>When no longer needed, data is deleted or anonymized.</p>
    <p>
      You may request deletion by contacting: <br />
      <a href="mailto:privacy@fr8bot.com">{{ 'privacy@fr8bot.com' }}</a>
    </p>

    <h2>DELIVERY & TRACKING DATA</h2>
    <p>Fr8bot may collect shipment-related data such as:</p>
    <ul>
      <li>Pickup and delivery confirmations</li>
      <li>Location tracking during transit</li>
      <li>Proof of delivery (including photos where applicable)</li>
    </ul>
    <p>This data is used for operational accuracy, dispute resolution, and service quality.</p>

    <h2>MARKETING COMMUNICATIONS</h2>
    <p>Users may receive operational and promotional communications.</p>
    <p>You can opt out by:</p>
    <ul>
      <li>Clicking “unsubscribe” in emails</li>
      <li>Replying STOP to SMS messages</li>
      <li>Contacting us directly</li>
    </ul>

    <h2>INTERNATIONAL USERS</h2>
    <p>
      Fr8bot operates in the United States. By using the Platform from outside the U.S., you consent
      to data transfer and processing in the U.S.
    </p>

    <h2>YOUR PRIVACY RIGHTS (U.S.)</h2>
    <p>
      Depending on your state (e.g., California, Texas, Colorado, Virginia), you may have rights to:
    </p>
    <ul>
      <li>Access your Personal Information</li>
      <li>Request correction</li>
      <li>Request deletion</li>
      <li>Opt out of certain data uses</li>
    </ul>
    <p>
      To exercise rights, contact: <br />
      <b
        ><a href="mailto:privacy@fr8bot.com">{{ 'privacy@fr8bot.com' }}</a></b
      >
    </p>

    <h2>CONTACT US</h2>
    <p>If you have questions about this Policy:</p>
    <p>
      <b>Fr8bot, Inc.</b> <br />
      Email: <a href="mailto:privacy@fr8bot.com">{{ 'privacy@fr8bot.com' }}</a>
    </p>

    <!--        -->
  </div>
</main>
